export const EVENT_TYPES = {
  CHILD_ADDED: 'child_added',
  CHILD_REMOVED: 'child_removed',
  CHILD_CHANGED: 'child_changed',
  VALUE: 'value',
};

export const ENTITY_SELECTOR_TYPES = {
  SELECTOR: 'SELECTOR',
  CHANNEL: 'CHANNEL',
  CONSTANT: 'CONSTANT',
};
